import {
  BottomSheetComponent,
  NavigationConfig,
  ParamListBase,
  registerBottomSheets,
  registerNavigationHandlers,
} from '@betty/navigation';
import { PromoDetailsScreenParams } from '../screens/PromoDetailsScreen/PromoDetailsScreen.types';
import PromosScreen from '../screens/PromosScreen';
import PromoDetailsScreen from '../screens/PromoDetailsScreen/PromoDetailsScreen';
import OptedInPromo from './bottomsheets/OptedInPromo/OptedInPromo';
import OptOutPromo from './bottomsheets/OptOutPromo/OptOutPromo';
import ReferrerPromoScreen from '../screens/ReferrerPromoScreen';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [
    {
      name: 'Promos',
      options: { headerShown: true },
      component: PromosScreen,
    },
    {
      name: 'PromoDetails',
      options: { headerShown: true },
      component: PromoDetailsScreen,
    },
    {
      name: 'ReferrerPromoScreen',
      options: { headerShown: true },
      component: ReferrerPromoScreen,
    },
  ],
  FULL_SCREEN_MODALS: [],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const bottomSheets = {
  OptedInPromo,
  OptOutPromo,
};

registerBottomSheets('promos', bottomSheets);

registerNavigationHandlers<AppNavigatorParamsList, 'Promos' | 'PromoDetails'>({
  Promos(navigate) {
    navigate('/promos');
  },
  PromoDetails(navigate, params) {
    if (!params) {
      return;
    }
    const { id } = params;

    navigate(`/promos/${id}`);
  },
});

declare global {
  interface RegisteredBottomSheets {
    promos: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}

declare global {
  interface AppNavigatorParamsList extends ParamListBase {
    Promos: undefined;
    PromoDetails: PromoDetailsScreenParams;
  }
}
